module.exports = __webpack_public_path__ + "svg/home-try-on.5ee0c847111e9ec68cd26d1601401b84.svg";